import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import ReactTable from 'react-table';
import { DragDropContext } from 'react-beautiful-dnd';
import {
  DragTrComponent,
  DropTbodyComponent,
} from '../Schedules/ScheduleDnDTable';
import { withTranslation } from 'react-i18next';

@inject('batchStore', 'ticketStore')
@observer
class BatchQueue extends Component {

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  handleDragEnd = result => {
    const { batchStore } = this.props;
    let data = batchStore.queue;

    batchStore.queue = this.reorder(
      data,
      result.source.index,
      result.destination.index
    );

  };

  onDelete = (ticket) => {
    const { batchStore } = this.props;
    batchStore.removeFromQueue(ticket.id);
  };

  getColumns = () => {
    const { batchStore, t } = this.props;
    const { canEmit } = batchStore;

    return [
      {
        Header: t('Mix'),
        id: 'mix',
        width: 160,
        sortable: false,
        accessor: d => (d.mix && d.mix.itemCode ? d.mix.itemCode : d.material ? d.material.code : ''),
      },
      {
        Header: t('Ticket'),
        accessor: d => d.tId,
        id: 'tId',
        className: 'sticky',
        headerClassName: 'sticky',
        width: 80,
        sortable: false,
      },
      {
        Header: t('Order'),
        accessor: d => (d.dispatchOrderCode || d.orderCode),
        id: 'code',
        className: 'sticky',
        headerClassName: 'sticky',
        width: 80,
        sortable: false,
      },
      {
        Header: t('Truck'),
        accessor: 'truckCode',
        id: 'truckCode',
        className: 'sticky',
        headerClassName: 'sticky',
        width: 80,
        sortable: false,
      },
      {
        Header: t('Drop'),
        id: 'currentDrop',
        width: 90,
        sortable: false,
        accessor: d => (`${d.currentDrop}/${d.allDrops}`),
      },
      {
        Header: t('Drop Size'),
        accessor: 'dropSize',
        id: 'dropSize',
        width: 90,
        sortable: false,
      },
      {
        Header: t('Batch Size'),
        accessor: 'batchSize',
        id: 'batchSize',
        width: 90,
        sortable: false,
      },
      {
        Header: t('Action'),
        sortable: false,
        width: 120,
        Cell: row => !(canEmit || batchStore.canSendRemoteInstruction()) ? '' : (
          <div className="actions text-right">
            <a className="btn btn-sm btn-default btn-action"
              title={t('Delete')}
              onClick={() => this.onDelete(row.original)}>
              <i className="fa fa-remove"/>
            </a>
          </div>
        ),
      },
    ];
  };

  getTrProps = (state, rowInfo) => {
    return { rowInfo };
  };

  render() {
    const { batchStore, t } = this.props;
    const { queue, queueSize, canEmit } = batchStore;

    return (
      <div>
        <div>
          <h5>
            {t('Queue')} {queueSize} ({queue.length}){' '}
            {!!queue.length && (canEmit || batchStore.canSendRemoteInstruction()) && (
              <a className="btn btn-sm btn-default btn-action"
                title={t('Batch')}
                onClick={() => batchStore.startBatch()}>
                <i className="fa fa-play"/>
              </a>
            )}
          </h5>
          <DragDropContext onDragEnd={this.handleDragEnd}>
            <ReactTable
              TrComponent={DragTrComponent}
              TbodyComponent={DropTbodyComponent}
              getTrProps={this.getTrProps}
              data={queue}
              noDataText={' '}
              className=" queue-table"
              columns={this.getColumns()}
              showPaginationTop={false}
              showPaginationBottom={false}
              pageSizeOptions={[10, 20, 30]}
              showPageSizeOptions={false}
              resizable={false}
              minRows={1}
              defaultPageSize={100}
            />
          </DragDropContext>
        </div>
      </div>
    );
  }
}

export default withTranslation()(BatchQueue);
